import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textinputFn = /* @__PURE__ */ createRecipe('textinput', {
  "size": "medium"
}, [])

const textinputVariantMap = {
  "size": [
    "medium",
    "small",
    "large",
    "xlarge"
  ]
}

const textinputVariantKeys = Object.keys(textinputVariantMap)

export const textinput = /* @__PURE__ */ Object.assign(memo(textinputFn.recipeFn), {
  __recipe__: true,
  __name__: 'textinput',
  __getCompoundVariantCss__: textinputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textinputVariantKeys,
  variantMap: textinputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textinputVariantKeys)
  },
  getVariantProps: textinputFn.getVariantProps,
})